export default "__VITE_ASSET__724a989b__"